module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-index-settings"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(_vm._s(_vm.$t("static.products.indexSettings.displayType")) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center margin-b-10"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": _vm.primary,
      "icon": "el-icon-menu",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('info')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("static.products.indexSettings.views.grid")))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.info,
      "icon": "el-icon-tickets",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('primary')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("static.products.indexSettings.views.list")) + "\n      ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-t-10"
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(_vm._s(_vm.$t("static.products.indexSettings.groupBy")) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('div', [_c('el-radio-group', {
    attrs: {
      "round": ""
    },
    on: {
      "change": _vm.handleGroupByChange
    },
    model: {
      value: (_vm.group),
      callback: function($$v) {
        _vm.group = $$v
      },
      expression: "group"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "None"
    }
  }, [_vm._v(_vm._s(_vm.$t("static.products.indexSettings.groups.None")))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Producer"
    }
  }, [_vm._v(_vm._s(_vm.$t("static.products.indexSettings.groups.Producer")))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Type"
    }
  }, [_vm._v(_vm._s(_vm.$t("static.products.indexSettings.groups.Type")))])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-590b824e","hasScoped":false}!./src/app/components/productIndexSettingsPopup/productIndexSettingsPopup.html
// module id = 3021
// module chunks = 1